<template>
  <div>
    <van-popup
      v-model="isShow"
      lock-scroll
      close-on-popstate
      position="right"
      :style="{ height: '100%', width:'100%' }"
    >
      <ld-header
        @click-left="isShow = false"
        @click-right="complie"
      >
        <span
          slot="right"
          class="main-color"
        >
          {{ $t('B010','保存') }}
        </span>
      
        编辑个人信息
      </ld-header>
    
      <van-cell-group>
        <van-field
          :label="$t('D013','出生日期')"
          placeholder="请选择出生日期"
          v-model="born"
          @click="showDate = !showDate"
          input-align="left"
          readonly="true"
        />
        <van-popup
          lock-scroll="true"
          v-model="showDate"
          :close-on-popstate="true"
          position="bottom"
        >
          <van-datetime-picker
            v-model="currentDate"
            type="date"
            :min-date="MIN_DATE"
            :max-date="MAX_DATE"
            @cancel="showDate = false"
            @confirm="dateSelect"
          />
        </van-popup>
      </van-cell-group>
    </van-popup>
  </div>
</template>

<script>
import mixin from './mixin'
import { formatDate } from 'Utils/dateUtil'

export default {
  name: 'EditBorn',
  mixins: [mixin],
  data() {
    return {
      MIN_DATE: new Date('1940-01-01'),
      MAX_DATE: new Date(),
      showDate: false,
      currentDate: '',
      born: ''
    }
  },
  created () {
    this.born = this.empInfo.born
    this.currentDate = new Date(this.empInfo.born)
  },
  methods: {
    dateSelect (date) {
      this.showDate = false
      this.born = formatDate(date).date
    },
    complie () {
      if (!this.born) {
        this.$toast('请选择出生日期')
        return
      }
      
      this.empInfo.born = this.born
      this.save()
    }
  }
}
</script>